<template>
  <ExternalQueryList
      endpoint="/api/v2/competition-participants"
      :endpoint-filters="{competition_team_id: competitionTeam.id}"
      :headlines="headlines"
      :can-destroy="() => true"
      :can-show="() => false"
      :button-column-width="2"
      :checkbox-column-width="2"
  >
    <template v-slot:default="{ row: competitionParticipant }">
      <td>
        {{ competitionParticipant.attributes.user_full_name }}
      </td>
    </template>

    <template v-slot:modals="{ load }">
      <CreateModal :competition-team="competitionTeam" @created="load"/>
    </template>
  </ExternalQueryList>
</template>

<script>
import CreateModal from "../Modals/Create";
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'

export default {
  components: {CreateModal, ExternalQueryList},

  props: {
    competitionTeam: {
      required: true,
      type: Object
    }
  },

  computed: {
    headlines() {
      return [
        {width: 20, text: 'Name'},
      ]
    },
  }
}
</script>
